import { useState } from 'react';
const useForm = (initialValues) => {
    const [formdata,setformdata]=useState(initialValues);
    const handlechange=(e)=>e.target.files?setformdata({...formdata,...{[e.target.name]:e.target.files[0]}}):setformdata({...formdata,[e.target.name]:e.target.value});
    const [visible, setVisible] = useState(false);
    const [visibleBulkModal, setVisibleBulkModal] = useState(false);
    const [courseNameVisible, setCourseNameVisible] = useState(false);
    const [hookVisible, setHookVisible] = useState(false);


    const openform=()=>{
        setformdata({});
        setVisible(true)
    }
    const editform=(data)=>{
        setformdata({});
        setformdata(data);
        setVisible(true);
    }
    const resetForm = () => {
        setformdata(initialValues);
        setVisible(false);
    }

    const openBulkModal = () => {
        console.log("Opening Bulk Modal"); // Debug line
        setformdata({});
        setVisibleBulkModal(true);
    };
    
    const openCourseNameForm=()=>{
        setformdata({});
        setCourseNameVisible(true)
    }

    const openHooksForm=()=>{
        setformdata({});
        setHookVisible(true)
    }

    return {formdata,handlechange,visible, setVisible,openform,editform,resetForm,openBulkModal,visibleBulkModal,setVisibleBulkModal,openCourseNameForm, 
        courseNameVisible,setCourseNameVisible, hookVisible,setHookVisible,openHooksForm};
};
export default useForm;